'use client';

import { type StaticImport } from 'next/dist/shared/lib/get-img-props';

import {
  ImageWithFallback,
  type ImageWithFallbackProps,
} from '@shared/ui-components/image-with-fallback/image-with-fallback';

import DefaultFallbackImage from './fallback-image.svg';
import { imageLoader } from './image-loader';

type ImageWrapperProps = Omit<ImageWithFallbackProps, 'fallbackSrc'> & {
  fallbackSrc?: StaticImport | string;
  hasDefaultFallback?: boolean;
};

export const ImageWrapper = ({
  fallbackSrc,
  hasDefaultFallback,
  quality,
  ...rest
}: ImageWrapperProps) => {
  return (
    <ImageWithFallback
      {...rest}
      fallbackSrc={fallbackSrc ? fallbackSrc : hasDefaultFallback ? DefaultFallbackImage : ''}
      loader={imageLoader}
    />
  );
};
